'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.showSidebar = undefined;
exports.default = getCustomSidebarOption;

var _QueryParamsContainer = require('../../../globals/QueryParamsContainer');

var _QueryParamsContainer2 = _interopRequireDefault(_QueryParamsContainer);

var _OptsToPath = require('signup-ui-core/constants/OptsToPath');

var _CustomSidebarOptions = require('../custom/CustomSidebarOptions');

var _CustomSidebarOptions2 = _interopRequireDefault(_CustomSidebarOptions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getCustomSidebarOption() {
  var urlParam = _QueryParamsContainer2.default.get('trialId') || _QueryParamsContainer2.default.get(_OptsToPath.SIDEBAR_OPTION);
  if (urlParam) {
    return _CustomSidebarOptions2.default[urlParam] ? urlParam : null;
  }
  return null;
}

var showSidebar = exports.showSidebar = function showSidebar() {
  return _QueryParamsContainer2.default.get('show_sidebar') === 'true';
};